module.exports = __webpack_public_path__ + "static/a-xx-175-art-9d3040d186a769ff5a74713e17397e61.jpg";